import SuccessorBorrowerForm from './SuccessorBorrowerForm';

export default SuccessorBorrowerForm;
